module.exports = __webpack_public_path__ + "img/24-4.3a2cec21.jpg";